export default __webpack_public_path__ + "static/media/addedcart-icon.70521709.svg";